import { jsx as o } from "react/jsx-runtime";
import { memo as t } from "react";
import { u as i } from "./styled-components.browser.esm-3eb04950.js";
import { TooltipPopover as n } from "./tooltipPopover/TooltipPopover.js";
import { IconContainer as m } from "./IconContainer.js";
import { Q as p } from "./QuestionMarkCircleIcon-9d1cd363.js";
const v = t(function({ content: r, ...e }) {
  return /* @__PURE__ */ o(n, { size: "small", content: r, children: /* @__PURE__ */ o("div", { children: /* @__PURE__ */ o(m, { children: /* @__PURE__ */ o(l, { ...e }) }) }) });
}), l = i(p)`
  font-weight: 600;
  color: var(--border-color-base);
  line-height: 32px !important;
  font-size: 16px;
`;
export {
  v as default
};
//# sourceMappingURL=PopoverHelp.js.map
